export default __webpack_public_path__ + "static/media/asc-wh.b601707e.svg";